/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();

  // Handle different user profile structures consistently before early returns.
  const user = userProfile?.user || (userProfile && typeof userProfile === "object" ? userProfile : null);

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    }
  }, [token, userProfile, loading]);

  useEffect(() => {
    if (!userProfile && !loading && !token) {
      dispatch(logoutUser());
    }
  }, [userProfile, loading, token, dispatch]);

  useEffect(() => {
    if (!loading && token && user && !user.isAdmin && user.role !== "admin") {
      // Logout non-admin users and redirect to login
      dispatch(logoutUser());
    }
  }, [loading, token, user, dispatch]);

  // Check if user is authenticated
  if (loading) {
    return null; // Show nothing while loading
  }

  if (!userProfile || !token) {
    return <Navigate to={{ pathname: "/login" }} replace />;
  }

  if (!user || (!user.isAdmin && user.role !== "admin")) {
    return <Navigate to={{ pathname: "/login" }} replace />;
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
